<section class="e-tax-invoice-cta">
  <div class="box">
    <div class="box-wrapper">
      <div class="box-wrapper__heading">
        <ng-container *ngFor="let item of serviceList">
          <span>{{ 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_CTA.HEADING.1' | translate }}</span
          >&nbsp;<span class="box-wrapper__heading--layout">{{ item.data.businessesCreateInvoices.iv | number }}</span
          >&nbsp;<span>{{ 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_CTA.HEADING.2' | translate }}</span>
        </ng-container>
      </div>
      <div class="box-wrapper__btn">
        <a
          class="box-wrapper__btn--layout"
          [href]="'https://auth.flowaccount.com/' + this.translate.currentLang + '/Account/Register'"
          rel="noopener noreferrer"
          target="_blank"
          ><span>{{ 'PLATFORM_BUSINESSES_E_TAX_INVOICE.E_TAX_INVOICE_CTA.BTN' | translate }}</span></a
        >
      </div>
    </div>
  </div>
</section>
